import { createRouter, createWebHistory } from 'vue-router'
// const indexView = () => import('../views/indexView.vue')
// import { gettoken } from '../utils/auth'
const routes = [
    {
      path: '/',
      // redirect: '/demo',  // 重定向:重新指向其它path,会改变网址
      name: 'index',
      // component: indexView
      component: ()=> import('../views/exception/NotFound.vue'),
    },
    {
      path: '/demo',
      name: 'demo',
      // component: indexView
      component: ()=> import('../views/indexView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('../views/exception/NotFound.vue')
    }
]

const router = createRouter({
  history: createWebHistory(), // 确保这里与base一致
  // history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // let token = gettoken()
  
  // if(to.path === '/login' && !token){
    next()
  // }else{
  //   if(token){
  //     if (to.path === '/login') {
  //       next('/jsxbd')
  //     }else{
  //       next()
  //     }
  //   }else{
  //     next('/login')
  //   }
  // }
})


export default router
